export default {
  dataPermission: null,
}
